<template>

  <div id="publications">
    <h3 class="titles" style=" margin-top: 10px;">Publications</h3>
    <div style="border: 3px solid #CCCCCC; width: 300px"></div>
    <div style="font-size: 20px;text-align: left;margin-bottom: 20px;">
      * co-first authors <sup>#</sup>  corresponding authors
      <br>
    </div>
    
    <div class="box" style="padding: 1px;flex-wrap: wrap; word-wrap: break-word;  max-width: 100%; white-space: normal;">
        <li style="padding: 1px; list-style: none;">
          
          <!-- 1 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              Guo, T*., Yuan, Z*., Pan, Y., Wang, J., Chen, F., Zhang, M. Q<sup>#</sup>., & <b> Li, X<sup>#</sup>.</b> (2023).               
              <a href="https://link.springer.com/article/10.1186/s13059-023-03078-6" target="_blank" class="title1">
              SPIRAL: integrating and aligning spatially resolved transcriptomics data across different experiments, conditions, and technologies.
              </a> 
              Genome Biology, 24(1), 241.(IF= 16.5) 
              <a href="http://49.232.60.206:9000/pdf/spiral (3).pdf" target="_blank" download="spiral (3).pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue;">
              [Download PDF]
              </a>
            </div>
          </div>
          

          <br/>
          <br/>

          <!-- 2 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              <b>Li, X.</b> , Chen, W., Chen, Y., Zhang, X., Gu, J<sup>#</sup>., & Zhang, M. Q<sup>#</sup>. (2017). 
              <a href="https://academic.oup.com/nar/article-abstract/45/19/e166/4096349" target="_blank" class="title1">
              Network embedding-based representation learning for single cell RNA-seq data.
            </a>
             Nucleic acids research, 45(19), e166-e166.(IF= 16.1)
             <a href="http://49.232.60.206:9000/pdf/scrl.pdf" target="_blank" download="scrl.pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue">
              [Download PDF]
            </a>
            </div>
          </div>
          <br/>
          <br/>

          <!-- 3 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              Huo, Y., Guo, Y., Wang, J., Xue, H., Feng, Y., Chen, W., & <b> Li X<sup>#</sup></b>. (2023). 
              <a href="https://www.sciencedirect.com/science/article/pii/S1673852723001418" target="_blank" class="title1">
              Integrating multi-modal information to detect spatial domains of spatial transcriptomics by graph attention network.
            </a> Journal of Genetics and Genomics, 50(9), 720-733.(IF= 6.6)
            <a href="http://49.232.60.206:9000/pdf/SpaDAC.pdf" target="_blank" download="SpaDAC.pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue">
              [Download PDF]
            </a>
            </div>
          </div>
          <br/>
          <br/>

          <!-- 4 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              Guo, T., Chen, Y., Shi, M., <b> Li, X<sup>#</sup>.</b>, & Zhang, M. Q<sup>#</sup>. (2022). 
              <a href="https://academic.oup.com/nar/article-abstract/50/2/e8/6437994" target="_blank" class="title1">
              Integration of single cell data by disentangled representation learning.
            </a> Nucleic Acids Research, 50(2), e8-e8.(IF= 16.1)
            <a href="http://49.232.60.206:9000/pdf/scidrl.pdf" target="_blank" download="scidrl.pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue">
              [Download PDF]
            </a>
            </div>
          </div>
          <br/>
          <br/>
          
          <!-- 5 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              Yan, A*., Xiong, J*., Zhu, J*., <b>Li, X *.</b>, Xu, S., Feng, X., Ke, X., Wang, Z., Chen, Y., Wang, H., Zhang, M. Q <sup>#</sup>., Kee K <sup>#</sup>. (2022). 
              <a href="https://academic.oup.com/nar/article-abstract/50/19/11255/6765317" target="_blank" class="title1">
              DAZL regulates proliferation of human primordial germ cell by direct binding to precursor miRNAs and enhances DICER processing activity.
            </a> Nucleic acids research, 50(19), 11255-11272.(IF= 16.1)
            <a href="http://49.232.60.206:9000/pdf/DAZL.pdf" target="_blank" download="DAZL.pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue">
              [Download PDF]
            </a>
            </div>
          </div>
          <br/>
          <br/>

          <!-- 6 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              Huo, Y*., Wang, J*., Liu, C., Wang, J., Wang, C., Guo, W., Yuan, Z., Guo, T., Gu, J.,<b>Li, X <sup>#</sup></b>. (2024). 
              <a href="https://www.sciencedirect.com/science/article/abs/pii/S1673852724002376?via%3Dihub" target="_blank" class="title1">
              CancerSRT: a spatially resolved transcriptomics database for human cancers.
            </a>Journal of genetics and genomics, s1673-8527.(IF= 6.6)
            <a href="http://49.232.60.206:9000/pdf/cancerSRT.pdf" target="_blank" download="cancerSRT.pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue">
              [Download PDF]
            </a>
            </div>
          </div>
          <br/>
          <br/>
          
          <!-- 7 -->
          <div class="title" style="display: flex;">
            <div class="bull">&bull;</div>
            <div class="content">
              Wu, G., <b>Li, X <sup>#</sup>.</b>, Guo, W., Wei, Z., Hu, T., Shan, Y., & Gu, J<sup>#</sup>. (2022). 
              <a href="https://academic.oup.com/bib/article-abstract/23/2/bbab603/6519533" target="_blank" class="title1">
              JEBIN: analyzing gene co-expressions across multiple datasets by joint network embedding.
            </a>Briefings in Bioinformatics, 23(2), bbab603.(IF= 7.9)
            <a href="http://49.232.60.206:9000/pdf/JEBIN.pdf" target="_blank" download="JEBIN.pdf" style="font-size: 20px; font-family: Arial; text-decoration: none; color: blue">
              [Download PDF]
            </a>
            </div>
          </div>
          <br/>
          <br/>
        </li>
    </div>
  </div>
</template>

<script>
import Softwares from './Softwares'
export default {
  name: 'Publications',
  components: {Softwares}
}
</script>

<style scoped>
.titles{
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
  margin-top: 30px;
  font-family: Arial;
  font-size: 28px
}
.box{
  width: 100%;
  margin: auto;
  overflow: hidden;
  /*background-color: pink;*/
  font-size: 20px;
  color: black;
  padding: 0 0 40px 100px;
}

.box ul{
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: relative;
  transition: all 0.5s linear;
  top:0
}

.box ul:last-of-type{top:80px}

/* //.box ul:before{
//  content: "";
//  display: block;
//  width: 0;
//  height: 100%;
//  border:1px dashed #000;
//  position: absolute;
//  top:0;
//  left:30px
//} */

.box ul li{
  margin: 20px 60px 60px;
  position: relative;
  padding: 10px 20px;
  background:rgba(255, 255, 255, 0.3);
  color:#000;
  border-radius: 10px;
  line-height: 20px;
  width: 90%
}

/* //.box ul li > span{
//  content: "";
//  display: block;
//  width: 0;
//  height: 100%;
//  border:1px solid #000;
//  position: absolute;
//  top:0;
//  left:-30px
//}
//
//.box ul li > span:before,.box ul li > span:after{
//  content: "";
//  display: block;
//  width: 10px;
//  height: 10px;
//  border-radius: 50%;
//  background:#005BAC;
//  border:2px solid #000;
//  position: absolute;
//  left:-7.5px
//}
//
//.box ul li > span:before{top:-10px}
//.box ul li > span:after{top:95%} */

.box ul li .img_div{
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.box .title1{
  /*text-transform: uppercase;*/
  font-weight: 700;
  margin-bottom: 10px;
  font-size: 22px;
  width: 100%;
  text-align: left;
}

.box .title{
  /*text-transform: uppercase;*/
  margin-bottom: 10px;
  font-size: 22px;
  width: 100%;
  text-align: left;
}

.box .info{width: 90%;text-align: left}
.box .info:first-letter{text-transform: capitalize;line-height: 1.7}

.box .name{
  margin-top: 10px;
  text-transform: capitalize;
  /* //font-style: italic; */
  text-align: left;
  font-family: "Arial";
  width: 80%;
  margin-right: 20px
}

.box .time span{
  position: absolute;
  left: -110px;
  color:#000;
  font-size: 25px;
  font-weight: bold;
}
.box .time span:first-child{top:-16px}
.box .time span:last-child{top:94%}
#publications {
  width: 1000px;

  margin: auto;
}
.bull{
  text-align: center;
  padding-top: 7px;
}
.content{
  margin-left: 1%; 
  font-size: 25px;
}

a{
  font-size: 25px; 
  font-family: Arial; 
  text-decoration: none; 
  color: #000000;
}

@media (max-width: 768px) {
  .titles{
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
  margin-top: 30px;
  font-family: Arial;
  font-size: 25px
}
  #publications {
    width: 80%;
  }
  .content{
    margin-left: 1%; 
    font-size: 20px;
  }
  a{
    font-size: 20px; 
    font-family: Arial; 
    text-decoration: none; 
    color: #000000;
  }
  .bull{
  text-align: center;
  padding-top: 0px;
  }
  .title {
    margin-left: 1%; 
    font-size: 18px;
    word-wrap: break-word; /* 自动换行 */
  }

  .title1 {
    font-size: 18px;
    word-wrap: break-word; /* 自动换行 */
  }

  .box {
    padding: 0 20px;
  }
  .box .title{
  /*text-transform: uppercase;*/
  margin-bottom: 10px;
  font-size: 22px;
  max-width: 100%;
  text-align: left;
}
}

</style>



// WEBPACK FOOTER //
// src/components2/Publications.vue